import { htmlEscape } from '@edicom/common/string/htmlEscape';
import { renderChips } from './renderChips';

/**
 * Devuelve una función que pinta el html de 1 chips. en función de los parametros del view.
 *
 * @example de uso en el view:
 *  metadata: {
 *    template: "<span ec-tooltip='{TOTAL}'>{CALDTO}:{PERCENT}</span>",
 *    separator: ', ',
 *  },
 * @param {Object} viewField
 * @param {Object} engineApi
 * @returns {function}
 */
export function rendererTemplateIvan(viewField, engineApi) {
  const replaceAll = (templateStr, key, value) => {
    return templateStr.split(`{${key}}`).join(value);
  };
  const template = viewField.metadata.template;
  return ({ value, index, isSelected, isEditable }) => {
    return renderChips({
      index,
      theme: 'ec-alt',
      isSelected,
      isEditable,
      content: Object.keys(value)
        .reduce((acc, cur) => {
          const formatFn = getFormatFn(viewField, engineApi, cur);
          const valueFormatted = formatFn(value[cur]);
          return replaceAll(acc, cur, valueFormatted);
        }, template)
        .replace(/{.+}/g, ''),
    });
  };
}

/**
 * Devuelve una función para transformar el valor en string (y formatearlo bonito en función del view)
 *
 * @param {Object} viewField el viewField del registro
 * @param {Object} engineApi
 * @param {string} cur el nombre de lcampo que queremos pintar
 * @returns {Function}
 */
function getFormatFn(viewField, engineApi, cur) {
  try {
    // construimos el model completo del campo, ej "CAB.LIN.IMP" + "IMPORTE"
    const model = `${viewField.model}.${cur}`;
    // buscamos el viewField
    const currentViewField = engineApi.dictionary[model];
    // devolvemos el metodo valueToString(value)
    return engineApi.field.toString(currentViewField, engineApi);
  } catch (e) {
    // si no encontramos el viewField o cualquier error, solo escapamos:
    return htmlEscape;
  }
}
